import http from "@/settings/apiSettings"

class PORTAL_DashboardService {
  get(): Promise<any> {
    return http.clientPortalHR.get("/portal/dashboard", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  getCalendar(an?: number, luna?: number): Promise<any> {
    const params: any = {};
    if (an) params.an = an;
    if (luna) params.luna = luna;
    return http.clientPortalHR.get("/portal/dashboard/calendar", {
      params,
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_DashboardService();
